export class ListCredentialsProfilesResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "credentialsProfiles",
            "baseName": "credentialsProfiles",
            "type": "Array<CredentialsProfile>",
            "format": ""
        },
        {
            "name": "nextToken",
            "baseName": "nextToken",
            "type": "string",
            "format": ""
        },
        {
            "name": "totalCount",
            "baseName": "totalCount",
            "type": "number",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ListCredentialsProfilesResponse.attributeTypeMap;
    }
    constructor() {
    }
}
